import { List, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllExpiryDate } from "../../../redux/rtk/features/dashboard/dashboardSlice";
const { Option } = Select;

const DocumentExpiryBar = () => {
    const dispatch = useDispatch();
    const { sensitiveData, loading } = useSelector((state) => state?.dashboard);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(dayjs().format("MM"));
    const [selectedYear, setSelectedYear] = useState(dayjs().format("YYYY"));

    useEffect(() => {
        dispatch(getAllExpiryDate());
    }, [dispatch]);

    useEffect(() => {
        if (!Array.isArray(sensitiveData)) return; // Ensure sensitiveData is an array
    
        const formattedList = sensitiveData.map((data) => {
            const employeeId= data.user?.employeeId
            const documents = [
                { type: "Passport", date: data.passportExpiryDate },
                { type: "Visa", date: data.visaExpiryDate },
                { type: "Driver's License", date: data.DLExpiryDate },
            ];
            // Find the first expiring document
            const expiringDocument = documents
                .filter((doc) => doc.date)
                .sort((a, b) => new Date(a.date) - new Date(b.date))[0];
    
            return expiringDocument
                ? {
                      name: `${data.user?.firstName} ${data.user?.lastName}`, // Replace with actual user name if available
                      employeeId,
                      documentType: expiringDocument.type,
                      expiryDate: expiringDocument.date,
                      
                  }
                : null;
        });
    
        const filteredList = formattedList
            .filter((item) => item && dayjs(item.expiryDate).format("MM-YYYY") === `${selectedMonth}-${selectedYear}`);
    
        setFilteredData(filteredList);
    }, [sensitiveData, selectedMonth, selectedYear]);
    

    const handleMonthChange = (value) => {
        setSelectedMonth(value);
    };

    const handleYearChange = (value) => {
        setSelectedYear(value);
    };

    return (
        <div>
            <Select
                value={selectedMonth}
                onChange={handleMonthChange}
                style={{ marginRight: 16, width: 120 }}
            >
                {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                    <Option key={month} value={String(month).padStart(2, "0")}>
                        {dayjs().month(month - 1).format("MMMM")}
                    </Option>
                ))}
            </Select>

            <Select
                value={selectedYear}
                onChange={handleYearChange}
                style={{ marginRight: 16, width: 80 }}
            >
                {Array.from({ length: 10 }, (_, i) => i + dayjs().year()).map((year) => (
                    <Option key={year} value={String(year)}>
                        {year}
                    </Option>
                ))}
            </Select>

            <List
                loading={loading}
                itemLayout="horizontal"
                dataSource={filteredData}
                renderItem={(item) => (
                    <List.Item>
                        <List.Item.Meta
                            title={
                                <p className="text-base font-medium text-blue ml-4">{item.name}</p>
                            }
                            description={
                                <div> 
                                    <p className="text-sm text-gray-500 ml-4">
                                    EmployeeId: {item.employeeId}
                                    </p>
                                    <p className="text-sm text-gray-500 ml-4">
                                        Document: {item.documentType}
                                    </p>
                                    <p className="text-sm text-gray-500 ml-4">
                                        Expiry Date: {dayjs(item.expiryDate).format("DD/MM/YYYY")}
                                    </p>
                                </div>
                            }
                        />
                    </List.Item>
                )}
            />
        </div>
    );
};

export default DocumentExpiryBar;
